import { createClient } from "@supabase/supabase-js";

/**
 * Supabase client used for authentication only — login, session refresh,
 * obtaining the user's JWT to authorize calls against the marketplace
 * /api/admin/* endpoints. The SPA never reads or writes application data
 * directly; all data flows through the JWT-authenticated admin API where
 * the service role key lives server-side.
 *
 * `auth.lock` is set to a no-op: the admin SPA is single-tab by design,
 * so the Web Locks API coordination that auth-js uses by default isn't
 * needed, and it intermittently wedged getSession() on hard refresh —
 * leaving the app either stuck on the loading spinner (pre-timeout fix)
 * or logging the user out after a 5s timeout (post-timeout fix). With
 * the lock disabled, getSession reads localStorage directly and returns
 * in milliseconds, preserving the session across hard refresh.
 */
export const supabase = createClient(
  import.meta.env.VITE_SUPABASE_URL,
  import.meta.env.VITE_SUPABASE_ANON_KEY,
  {
    auth: {
      lock: async (_name, _acquireTimeout, fn) => fn(),
    },
  }
);
